import { CoursePagePremiumLoader } from "@/components/course/CoursePagePremiumLoader";
import { StuckLoadingRecovery } from "@/components/StuckLoadingRecovery";
import { useStuckLoadingTimeout } from "@/hooks/useStuckLoadingTimeout";
import { STAGE_LABELS } from "@/lib/loadingMessages";
import { StyleSheet, Text } from "react-native";
import { YStack } from "tamagui";

/**
 * Full-screen loading during SSO token exchange.
 */
export function SSOLoadingScreen() {
  const stuck = useStuckLoadingTimeout();
  if (stuck) return <StuckLoadingRecovery />;

  return (
    <YStack f={1} ai="center" jc="center" bg="$background" gap="$2">
      <CoursePagePremiumLoader variant="sso" />
      <Text style={styles.stage}>{STAGE_LABELS['sso:processing']}</Text>
    </YStack>
  );
}

const styles = StyleSheet.create({
  stage: {
    fontSize: 15,
    fontWeight: '600',
    color: '#444',
    textAlign: 'center',
  },
});
